import React from "react"
import classes from "./Tabs.module.css"
import Tab from "./Tab/Tab"
import { useTranslation } from "react-i18next"

const Tabs = props => {
    const { t } = useTranslation()

    const TABS = [t("misc:Checker.TabShowAllResults"), t("misc:Checker.TabSearchTarget")]
    return (
        <ul className={classes.Nav}>
            {TABS.map((v, idx) => {
                return <Tab title={v} key={idx} clicked={props.clicked} active={props.active === idx} num={idx} />
            })}
        </ul>
    )
}

export default Tabs
